export enum UserCapabilityName {
  FeatureToggleAdmin = 'EDIT_FEATURE_TOGGLES',
  FeatureToggleViewer = 'VIEW_FEATURE_TOGGLES',
}

export const toUserCapabilityEnum = (val: string): UserCapabilityName => {
  return UserCapabilityName[val as keyof typeof UserCapabilityName];
};
